import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';

import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';
import { chainsRoutesConfig } from 'domains/chains/routes';

const NotificationsPage = loadable(
  async () => {
    const module = await import('./NotificationsPage');

    return module.NotificationsPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const chainsPath = chainsRoutesConfig.chains.generatePath();

export const NotificationsPageContainer = () => {
  return (
    <Page>
      <NoSSRGuard>
        <LoggingInGuard fallback={<Navigate to={chainsPath} />}>
          <NotificationsPage />
        </LoggingInGuard>
      </NoSSRGuard>
    </Page>
  );
};
